import { render } from "./childrenHeader.vue?vue&type=template&id=c8a25d74&scoped=true&ts=true"
import script from "./childrenHeader.vue?vue&type=script&lang=ts"
export * from "./childrenHeader.vue?vue&type=script&lang=ts"

import "./childrenHeader.vue?vue&type=style&index=0&id=c8a25d74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a25d74"]])

export default __exports__